import {
  PARENTAL_CHECK_PIN,
  PARENTAL_CHECK_PIN_SUCCESS,
  PARENTAL_SEND_OTP,
  PARENTAL_SEND_OTP_SUCCESS,
  PARENTAL_SET_PIN_SUCCESS,
  PARENTAL_SET_PIN_ERROR,
  CHANGE_CHECK_PIN,
  CHANGE_CHECK_PIN_SUCCESS,
  PARENTALCONTROL_LOAD_SUCCESS,
  CHANGE_CHECK_PIN_RESET,
  RESET_PARENTAL,
  SET_RESTART_PARENTAL
} from './actions';

const initialState = {
  checkLoaded: false,
  pinCheck: false,
  otpSent: false,
  setPinSuccess: false,
  setPinError: false,
  changeCheckLoaded: false,
  changePinCheck: false,
  pinValue: null,
  restartParental: false
};

export function parentalReducer(state = initialState, action) {
  let data = action.payload;

  switch (action.type) {
    case PARENTAL_CHECK_PIN:
      return {
        ...state,
        checkLoaded: false,
        pinCheck: false,
        pinValue: null
      };

    case PARENTAL_CHECK_PIN_SUCCESS:
      let newPinValue = null;

      if (action.pin) {
        newPinValue = action.pin;
      }

      return {
        ...state,
        checkLoaded: true,
        pinCheck: data,
        pinValue: newPinValue
      };

    case PARENTAL_SEND_OTP:
      return {
        ...state,
        setPinError: false
      };

    case PARENTAL_SEND_OTP_SUCCESS:
      return {
        ...state,
        otpSent: true
      };

    case PARENTAL_SET_PIN_SUCCESS:
      return {
        ...state,
        setPinSuccess: true
      };

    case PARENTAL_SET_PIN_ERROR:
      return {
        ...state,
        setPinError: true
      };

    case CHANGE_CHECK_PIN:
    case PARENTALCONTROL_LOAD_SUCCESS:
    case CHANGE_CHECK_PIN_RESET:
      return {
        ...state,
        changeCheckLoaded: false,
        changePinCheck: false
      };

    case CHANGE_CHECK_PIN_SUCCESS:
      return {
        ...state,
        changeCheckLoaded: true,
        changePinCheck: data
      };

    case RESET_PARENTAL:
      return {
        ...initialState
      };

    case SET_RESTART_PARENTAL:
      if (data) {
        return {
          ...initialState,
          restartParental: data
        };
      }

      return {
        ...state,
        restartParental: data
      };

    default:
      return state;
  }
}
